export enum QuestionTypes {
  Criteria = 1,
  Supplementary = 2
}
